import { accessToken, retry } from '@/shared/auth'
import { Middleware } from 'openapi-typescript-fetch'

export const addToken: Middleware = async (url, init, next) => {
  accessToken.value &&
    init.headers.append('Authorization', `Bearer ${accessToken.value}`)

  let response = next(url, init)
  try {
    const r = await response

    if (r.status === 401) {
      await retry()

      if (accessToken.value) {
        init.headers.append('Authorization', `Bearer ${accessToken.value}`)
        response = next(url, init)
      }
    }
  } catch (e) {
    if (e.status === 401) {
      await retry()

      if (accessToken.value) {
        init.headers.append('Authorization', `Bearer ${accessToken.value}`)
        response = next(url, init)
      }
    }
  }

  return response
}
